import alertConfigurationService from "../../../../api/alertConfiguration.service.js";
import userService from "../../../../api/api.service.js";
import rules from "../../../../utils/rules.js";

export default {
  data() {
    return {
      isNotificationLoading: true,
      modelDialog: false,
      saveConfigLoading: false,
      confirmUpdating: false,
      confirmDialog: false,
      isUpdatingAlert: false,
      form: null,
      mobileNumber: "",
      isContactProcessing: false,
      firstName: "",
      email: "",
      phoneCountryCode: "1",
      phoneCountryName: "us",
      contactsList: [],
      contactsLoading: false,
      appNotification: false,
      appNotificationUsers: [],
      smsNotification: false,
      smsNotificationUsers: [],
      smsNotificationContacts: [],
      emailNotification: false,
      emailNotificationUsers: [],
      emailNotificationContacts: [],
      usersList: [],
      usersLoading: false,
      enableAutoAcknowledge: true,
      isLoading: false,
      rules: rules,
    };
  },
  props: {
    dataToPreference: {
      type: Object,
      required: false,
    },
    dataToPreferenceWithObject: {
      type: Object,
      required: false,
    },
    isPermissionOn: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    async getUsers() {
      this.usersList = [];
      this.usersLoading = true;
      try {
        let response = await userService.getUsers();
        if (response) {
          this.usersList = response.data.map((d) => ({
            id: d.id,
            fullName: d.firstName ? d.firstName + " " + d.lastName : "",
            email: d.email,
            roleName: d.role,
          }));
          this.usersLoading = false;
        }
      } catch (error) {
        this.usersLoading = false;
        this.$toast.error("Unable to load Users");
      }
    },

    async getContacts() {
      this.contactsList = [];
      this.contactsLoading = true;
      try {
        let response = await userService.getAllUsers();
        if (response && response.data) {
          this.contactsList = response.data.map((d) => ({
            id: d.id,
            fullName: d.name,
            email: d.email,
          }));
        }
        this.contactsLoading = false;
      } catch (err) {
        this.contactsLoading = false;
        console.log(err);
      }
    },

    async contactSave() {
      let userPhoneNumber = this.mobileNumber
        ? this.mobileNumber.replace(/\D+/g, "")
        : "";

      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let payloaduser = {
            name: this.firstName,
            email: this.email,
            phone: userPhoneNumber,
          };
          let apiResponse = await userService.createContact(payloaduser);
          if (apiResponse.isSuccess) {
            this.loading = false;
            this.modelDialog = false;
            this.$refs.form.reset();
            this.$toast.success("Contact is Successfully Created");
            this.getContacts();
          } else {
            this.loading = false;
            this.$toast.error("Unable to Create Contact");
          }
        } catch (err) {
          this.loading = false;
          this.$toast.error("Unable to create contact" + err);
        }
      }
    },

    // ── Build payload ───────────────────────────────────────────
    buildPayload() {
      const src = this.dataToPreference || {};
      const fallback = JSON.parse(localStorage.getItem("AlertPreferenceSaveObj")) || {};

      const get = (key) => (src[key] !== undefined ? src[key] : fallback[key]);

      return {
        eventId: get("eventId") || null,
        alertName: get("alertName") || null,
        criticality: get("criticality") || null,
        logicalOperator: get("logicalOperator") || null,
        referenceFieldName: get("referenceFieldName") || null,
        referenceFieldValue: get("referenceFieldValue") || [],
        startDate: get("startDate") || null,
        endDate: get("endDate") || null,
        enabled: get("enabled") !== undefined ? get("enabled") : true,
        configurationData: get("configurationData") || [],
        notificationConfiguration: {
          applicationNotification: {
            trigger: this.appNotification,
            users: this.appNotificationUsers ? this.appNotificationUsers.join(",") : "",
            roles: "",
            matchedEquipment: false,
          },
          emailNotification: {
            trigger: this.emailNotification,
            users: this.emailNotificationUsers ? this.emailNotificationUsers.join(",") : "",
            contacts: this.emailNotificationContacts ? this.emailNotificationContacts.join(",") : "",
            roles: "",
            matchedEquipment: false,
          },
          smsNotification: {
            trigger: this.smsNotification,
            users: this.smsNotificationUsers ? this.smsNotificationUsers.join(",") : "",
            contacts: this.smsNotificationContacts ? this.smsNotificationContacts.join(",") : "",
            roles: "",
            matchedEquipment: false,
          },
          badgeNotification: {
            trigger: true,
            users: "",
            triggerringEntity: "",
          },
        },
        isAutoAcknowledged: this.enableAutoAcknowledge,
        isConfirmFlag: this.confirmUpdating,
      };
    },

    async saveAlertConfiguration() {
      try {
        this.saveConfigLoading = true;
        const payload = this.buildPayload();

        if (this.$route.params.id) {
          const response = await alertConfigurationService.updateAlertConfiguration(
            this.$route.params.id,
            payload
          );
          if (response.isSuccess) {
            this.saveConfigLoading = false;
            this.confirmDialog = false;
            this.confirmUpdating = false;
            this.isUpdatingAlert = false;
            this.$toast.success(response.systemMessage);
            this.$emit("navigateToAlertsList");
          } else if (!response.isSuccess && response.statusCode === 409) {
            this.confirmDialog = true;
          }
        } else {
          const response = await alertConfigurationService.saveAlertConfiguration(payload);
          if (response.isSuccess) {
            this.saveConfigLoading = false;
            this.$toast.success(response.systemMessage);
            localStorage.removeItem("AlertPreferenceSaveObj");
            localStorage.removeItem("selectedEquipmentsChecked");
            this.$emit("navigateToAlertsList");
          } else {
            this.saveConfigLoading = false;
            this.$toast.error("! Unable to save the Alert");
          }
        }
      } catch (error) {
        this.saveConfigLoading = false;
        this.$toast.error("! Unable to save the Alert");
        console.log(error);
      }
    },

    handleBack() {
      this.$emit("navigateToAlertConfiguration");
    },

    handleClose() {
      this.$refs.form.reset();
      this.modelDialog = false;
    },

    confirmUpdateAlert() {
      this.isUpdatingAlert = true;
      this.confirmUpdating = true;
      this.saveAlertConfiguration();
    },

    cancelConfirmDialog() {
      this.confirmUpdating = false;
      this.saveConfigLoading = false;
      this.confirmDialog = false;
    },

    onNewAddUser() {
      this.$router.push({ path: "/user-management/add" });
    },

    openDialog() {
      this.modelDialog = true;
    },

    onSelectPhone({ iso2, dialCode }) {
      this.phoneCountryCode = dialCode;
      this.phoneCountryName = iso2;
    },

    bindForm() {
      try {
        if (this.dataToPreferenceWithObject) {
          const d = this.dataToPreferenceWithObject;
          const nc = d.notificationConfiguration || {};

          this.appNotification = nc.applicationNotification?.trigger || false;
          this.appNotificationUsers = nc.applicationNotification?.users
            ? nc.applicationNotification.users.split(",").filter(Boolean)
            : [];

          this.emailNotification = nc.emailNotification?.trigger || false;
          this.emailNotificationUsers = nc.emailNotification?.users
            ? nc.emailNotification.users.split(",").filter(Boolean)
            : [];
          this.emailNotificationContacts = nc.emailNotification?.contacts
            ? nc.emailNotification.contacts.split(",").filter(Boolean)
            : [];

          this.smsNotification = nc.smsNotification?.trigger || false;
          this.smsNotificationUsers = nc.smsNotification?.users
            ? nc.smsNotification.users.split(",").filter(Boolean)
            : [];
          this.smsNotificationContacts = nc.smsNotification?.contacts
            ? nc.smsNotification.contacts.split(",").filter(Boolean)
            : [];

          this.enableAutoAcknowledge = d.isAutoAcknowledged !== undefined ? d.isAutoAcknowledged : true;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async fetchData() {
      await this.getUsers();
      await this.getContacts();
      if ("id" in this.$route.params) {
        this.bindForm();
      }
      this.isNotificationLoading = false;
    },
  },

  mounted() {
    this.fetchData();
  },
};
